// Procesamos la carga de datos a la nube

import { ApiCallPost } from "./ApiCall/ApiCall";

import * as XLSX from 'xlsx'

var hojaName = "Detalle"
const fieldName = "" ; 

function UploadDataProcess( files , endpoint ) {
    console.log( "handleUpload")


    return new Promise( (resolve , reject ) => {

    

    const reader = new FileReader() ; 
    reader.readAsBinaryString(files[0]) // e.target.files[0]

    reader.onload = async (e) => {
        const data2 = e.target.result ;
        const workbook = XLSX.read( data2 ,{ type : "binary"  , cellDates: true , cellNF: true}) // 
        //const workbook = XLSX.readFile( data ,{cellDates: true , type : "binary"})
        //const sheetName = workbook.SheetNames[0] ;

        //setShName( sheetName );

        console.log( "Lista de pestañas")   
        for( var i = 0 ; i <  workbook.SheetNames.length ; i++  )
        {
            console.log( workbook.SheetNames[i]) 
        }
        
        //hojaName = workbook.SheetNames[0] ;

        //const sheet = workbook.Sheets[sheetName] ;
        
        //const sheet = workbook.Sheets['c_Aduana'] ; // c_Pais

        var theField = ""

        if ( fieldName!== "") // =>>>>>
        {
            // Usamos el nombre el campo
            theField = fieldName ;
            console.log( "Usamos fieldName")
        }else {
            theField = hojaName ;
            console.log( "Usamos hojaName " + theField )
        }

        console.log( "HojaName = " + hojaName )

        const sheet = workbook.Sheets[hojaName] ; // c_Pais

        const parseData = XLSX.utils.sheet_to_json( sheet , { header : 1 })


        var newParse = [] ; // Este es el arreglo de registros


        var isFound = false ;


        console.log( "Length = " +  parseData.length)

        for ( var row = 0 ; row <  parseData.length ; row ++)
        {
            // if ( row < 9 )
            // {
            //     console.log( "row:" + row + " " + parseData[row]) ;
            // }
            
            console.log( "row = " + row )

            if ( row < 9  && typeof parseData[row][0] === "string" )
            {
                console.log( "row:" + row + " " + parseData[row][0].toUpperCase()) ;
                console.log( "hojaName = " + theField.toUpperCase())
            }


            console.log( "typeOf = " , parseData[row][0] )

            console.log( "numTel = " , parseData[0][0] )

            if ( parseData[0][0] !== "NumTel" )
            {
                resolve( "El archivo no corresponde") ;
                return ;
            }
            

            if ( typeof parseData[row][0] === "string")
            {
                if ( parseData[row][0].toUpperCase() === theField.toUpperCase() 
                    /*sheetName */)
                {
                    isFound = true ;
                }
            }

            isFound = true ;



            if ( isFound )
            {
                newParse.push( parseData[row] ) ;
            }

        }


 
        console.log( "Saliendo de " + theField + " isFound = " + isFound )

        console.log( "newParse = " , newParse )

        // El end point lo podemos parametrizar
        ApiCallPost( endpoint , newParse ) // Aqui debemos de poner la ruta
        .then( (res) => {
            console.log( "Respuesta de la ApiCall")
            console.log( res )

            resolve( res )
            return ;

        })
        .catch( (err) => {
            console.log( "Error en la ApiCall")
            console.log( err )

            resolve( "err")

            return ;
        })

        console.log( "Despues del ApiCall") ;

        //setData( newParse ) ;



        console.log( "Despues de parseData " + newParse.length )
        

        //console.log( data) ;

    }

    })
}

export default UploadDataProcess